// extracted by mini-css-extract-plugin
export default {"banner":"banner-centered-module--banner--hEXSM","text":"banner-centered-module--text--Z4003"};